import React, {useEffect, useState} from 'react';
import {classes, style} from './doppe-action-type-widget-collapsable-container.st.css';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {DoppeViewerHorizontalButton} from '../doppe-viewer-horizontal-button/doppe-viewer-horizontal-button';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {
    DoppeActionTypeSpeedDialWidgetIconChevronDown,
    DoppeActionTypeSpeedDialWidgetIconChevronUp
} from '../../doppe-action-types/doppe-action-type-speed-dial/doppe-action-type-speed-dial-widget/doppe-action-type-speed-dial-widget-icons';

export const DoppeActionTypeWidgetCollapsableContainer = React.memo(function DoppeActionTypeWidgetCollapsableContainer(props: DoppeActionTypeWidgetCollapsableContainer.Props) {
    const {
        children,
        title,
        isOpenedByDefault = false,
        hideTitle = false,
        isCollapsable = true,
        withInnerPadding = false,

        className,
        ...htmlAttributes
    } = props;

    const [isStateOpened, setIsStateOpened] = useState(isOpenedByDefault || hideTitle || !isCollapsable);

    const isActualOpen = isStateOpened || !isCollapsable || hideTitle;

    useEffect(() => {
        setIsStateOpened(isOpenedByDefault)
    }, [isOpenedByDefault]);

    useEffect(() => {
        if (hideTitle) {
            setIsStateOpened(true)
        }
    }, [hideTitle]);

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                hasHeader: !hideTitle,
                withInnerPadding: withInnerPadding
            }, className)}
        >
            {
                !hideTitle ?
                    <div
                        className={style(classes.header, {}, FlexLayout.row.alignToTop, FlexLayout.justifyContent.spaceBetween, CommonClasses.button)}
                        onClick={() => setIsStateOpened(!isStateOpened)}
                    >
                        <DoppeActionTypeWidgetInnerTitle
                            className={style(classes.title, {}, !isActualOpen ? CommonClasses.ellipsis : undefined)}
                        >
                            {title}
                        </DoppeActionTypeWidgetInnerTitle>
                        {
                            isCollapsable ?
                                <DoppeViewerHorizontalButton
                                    textual={true}
                                    className={style(classes.openButton, {})}
                                    prefixIcon={isStateOpened ? DoppeActionTypeSpeedDialWidgetIconChevronUp : DoppeActionTypeSpeedDialWidgetIconChevronDown}
                                />
                                :
                                null
                        }
                    </div>
                    :
                    null
            }
            {
                isActualOpen ?
                    <div
                        className={style(classes.content, {})}
                    >
                        {children}
                    </div>
                    :
                    null
            }
        </div>
    );
});

export namespace DoppeActionTypeWidgetCollapsableContainer {

    export interface Props extends React.HTMLAttributes<any> {
        title: string;
        isCollapsable?: boolean;
        isOpenedByDefault?: boolean;
        hideTitle?: boolean;
        withInnerPadding?: boolean;
    }
}
